export type CommunityOptInState = {
  currentState: CommunityOptInStateType;
  hasWithdrawnBefore: boolean;
};
export enum CommunityOptInStateType {
  INITIAL,
  ACCEPTING,
  ACCEPTING_FAILED,
  ACCEPTED,
}
export type OptInPayload = {
  hasWithdrawnBefore: boolean;
};
export type CommunityOptInAction = {
  type: CommunityOptInStateType;
  payload?: OptInPayload;
};

export const CommunityOptInReducer = (
  state: CommunityOptInState,
  action: CommunityOptInAction,
): CommunityOptInState => {
  const { type, payload } = action;
  return {
    currentState: type,
    hasWithdrawnBefore:
      payload != null ? payload.hasWithdrawnBefore : state.hasWithdrawnBefore,
  };
};
